import { styled } from '@mui/material';

export const CommentListWrapper = styled('div')<{ replies?: boolean }>`
  & > * {
    margin-bottom: ${({ theme }) => theme.spacing(7)};
  }
  & > *:last-child {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
  padding: ${({ theme, replies }) =>
    replies ? theme.spacing(4, 0, 4, 10) : theme.spacing(4, 0)};
`;
